function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// @mui imports
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
// @limitless
import { useTranslation } from "@limitless/common/hooks";
import Typography from "../../data-display/typography/Typography";
import CloseIcon from "@limitless/icons/Close";
const AlertRef = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    title,
    description,
    showCloseIcon,
    severity,
    ...rest
  } = props;
  const severityColour = theme => {
    if (severity === "error") {
      return {
        color: theme.palette.error.dark
      };
    } else if (severity === "success") {
      return {
        color: theme.palette.success.main
      };
    }
    return {};
  };
  return /*#__PURE__*/React.createElement(MuiAlert, _extends({
    elevation: 4,
    ref: ref,
    variant: "filled",
    action: showCloseIcon && /*#__PURE__*/React.createElement(IconButton, {
      onClick: props.onClose,
      sx: {
        padding: "4px"
      },
      disableRipple: true
    }, /*#__PURE__*/React.createElement(CloseIcon, {
      sx: {
        color: theme => theme.palette.primary.dark
      }
    })),
    severity: severity
  }, rest), title !== "" && /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    sx: theme => severityColour(theme)
  }, title), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    sx: theme => severityColour(theme)
  }, description));
});
AlertRef.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onClose: PropTypes.func,
  showCloseIcon: PropTypes.bool,
  severity: PropTypes.string
};
AlertRef.displayName = "AlertRef";
const Alert = ({
  id = "alert-default-id",
  title = "",
  description = "",
  severity = "error",
  autoHideDuration = 6000,
  showCloseIcon = false,
  open = false,
  onClose,
  payload
}) => {
  const {
    t
  } = useTranslation();
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    onClose();
  };
  return /*#__PURE__*/React.createElement(Snackbar, {
    open: open,
    autoHideDuration: autoHideDuration,
    anchorOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(AlertRef, {
    onClose: handleClose,
    severity: severity,
    sx: {
      width: "100%",
      padding: `${title !== "" ? "12px" : "17px"}`
    },
    id: id,
    title: t(title, payload),
    description: t(description, payload),
    variant: "standard",
    showCloseIcon: showCloseIcon
  }));
};
Alert.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  severity: PropTypes.string,
  autoHideDuration: PropTypes.number,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  showCloseIcon: PropTypes.bool,
  payload: PropTypes.string
};
export default Alert;